function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8334 16.6824C29.8334 9.27359 23.8639 3.26758 16.5001 3.26758C9.13628 3.26758 3.16675 9.27359 3.16675 16.6824C3.16675 23.378 8.04253 28.9279 14.4167 29.9342V20.5601H11.0313V16.6824H14.4167V13.7269C14.4167 10.3649 16.4074 8.50774 19.4529 8.50774C20.9113 8.50774 22.4376 8.76975 22.4376 8.76975V12.0711H20.7563C19.1001 12.0711 18.5834 13.1052 18.5834 14.1671V16.6824H22.2813L21.6902 20.5601H18.5834V29.9342C24.9576 28.9279 29.8334 23.378 29.8334 16.6824Z",
  fill: "#487C71"
});

function SvgFacebookNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookNegative);
export default __webpack_public_path__ + "static/media/facebook-negative.b0b91699.svg";
export { ForwardRef as ReactComponent };